import { exitWord } from '@/components/process/stepDrawerText'
import { outcomeWords } from '@/components/process/stepLiveText'
import type { RecordProcessRead, TaskRead } from '@/types/process'

/** SA-1078: the task page's own words (UX pass spec move 3, "Task page"). */

export const BREADCRUMB = 'Breadcrumb'

/** "Step 10 · Propose rate" — the breadcrumb's last crumb. */
export const stepCrumb = (number: number, title: string): string => `Step ${number} · ${title}`

/** "Quote CCA-0142" — the record as an origin, under the deployment's noun. */
export const recordOriginLabel = (noun: string, orderNumber: string): string => `${noun} ${orderNumber}`

export const AI_TOLD = 'What the AI is told'
/** The disclosure's memory, per viewer and device (the `step-drawer:details` precedent). */
export const AI_TOLD_KEY = 'task-page:ai-context'

/** SA-1328: the toast after Done: the step and the exit's label, then where the record is now. */
export function doneToast(
  task: Pick<TaskRead, 'step_id' | 'step_number' | 'step_title' | 'exits'>,
  exit: string,
  record: Pick<RecordProcessRead, 'status' | 'closed_outcome' | 'current_step'>,
): string {
  const label = task.exits?.find((e) => e.name === exit)?.label?.trim()
  const head = `${task.step_number} ${task.step_title} · ${label || exitWord(exit)}`
  if (record?.status === 'closed') {
    const outcome = outcomeWords(record.closed_outcome)
    return outcome ? `${head} · closed · ${outcome}` : `${head} · closed`
  }
  const step = record?.current_step
  if (!step) return head
  if (step.id === task.step_id) {
    return step.seat_label ? `${head} · still at this step, waiting on ${step.seat_label}` : `${head} · still at this step`
  }
  const at = `${step.number} ${step.title}`
  return step.seat_label ? `${head} · waiting on ${step.seat_label} at ${at}` : `${head} · now at ${at}`
}
